module.exports = __webpack_public_path__ + "static/apple-banner2x-0b031c82f8c28b0d7719d0b2d41f437c.jpg";